module.exports = __webpack_public_path__ + "img/logoElectricalMarine.f9a31f29.png";